export const storiesData = [
  {
    id: 1,
    name: 'Surya Pokhrel',
    description:
      "A story of resilience—defying the odds and daring to dream of technology from one of Nepal's most remote regions.",
    slug: 'surya-pokhrel-1',
    image: require(`@/assets/img/whymatter-surya.jpg`),
    quote:
      'In a place where survival was everything, dreaming of technology felt unreachable—but I chose to chase it anyway.',
    role: 'Frontend Developer at DIGU',
    videoUrl: 'https://www.youtube.com/watch?v=SNxAPnexHAo',
    body: [
      {
        title: 'Surya Pokhrel: From Kalikot to Code',
        description:
          "Born in the remote district of Kalikot during a time of conflict, Surya Pokhrel's journey into tech began far from Wi-Fi and whiteboards. Raised away from his parents and shaped by hardship, he first encountered computers at a school in Surkhet—mesmerized by volunteers typing on MacBooks with ease. That moment lit a spark.",
      },
      {
        description:
          "From living through Nepal's insurgency to facing rejection in Kathmandu's job market, Surya's path was anything but easy. But curiosity, grit, and a dream of building a more connected life led him to software development.",
      },
      {
        description:
          "Today, Surya is a developer at DIGU, contributing to global projects from Nepal. 'DIGU didn't just give me a job —it gave me a platform to prove that talent can rise from anywhere,' he shares. 'To those in Kalikot and beyond, your starting point doesn't define your future. Code your way forward.'",
      },
      // {
      //   description:
      //     "<b>Surya says:</b> 'Your starting point doesn't define your future. Code your way forward.'",
      // },
    ],
  },
  // {
  //   id: 2,
  //   name: 'Ujjwal Raja',
  //   description:
  //     'A journey of innovation—turning challenges into opportunities through technology in Nepal.',
  //   slug: 'ujjwal-Raja-2',
  //   image: require(`@/assets/img/ujjwal_raja_maharjan.webp`),
  //   quote: "Technology is not just a tool; it's a bridge to a better future.",
  //   role: 'Backend Developer at DIGU',
  //   videoUrl: 'https://www.youtube.com/watch?v=9bZkp7q19f0',
  //   body: [
  //     {
  //       title: 'Ujjwal Raja: Building Bridges with Code',
  //       description:
  //         'Ujwal grew up in Raja, where access to technology was limited but his ambition was boundless. His fascination with coding began in a local library with outdated computers.',
  //     },
  //     {
  //       description:
  //         'Despite limited resources, Ujwal taught himself programming through online forums and sheer determination. His persistence led him to DIGU, where he now builds scalable solutions for global clients.',
  //     },
  //     {
  //       description:
  //         "'DIGU gave me the chance to turn my passion into impact,' Ujwal says. 'Every line of code I write is a step toward a more connected Nepal.'",
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   name: 'Nikisha Shrestha',
  //   description:
  //     'Empowering communities through education and technology in rural Nepal.',
  //   slug: 'Nikishashrestha-3',
  //   image: require(`@/assets/img/nischal_shakya.webp`),
  //   quote:
  //     'Education and technology can transform lives, no matter where you start.',
  //   role: 'Full Stack Developer at DIGU',
  //   videoUrl: 'https://www.youtube.com/watch?v=3tmd-ClpJxA',
  //   body: [
  //     {
  //       title: 'Nikisha Shrestha: Coding for Change',
  //       description:
  //         'Nikisha hails from a small village in Gorkha, where she saw firsthand the power of education. She pursued computer science against all odds, driven by a desire to uplift her community.',
  //     },
  //     {
  //       description:
  //         "At DIGU, Nikisha develops applications that make education accessible. 'Technology can break barriers,' she says. 'I'm proud to contribute to that mission.'",
  //     },
  //   ],
  // },
];

storiesData.forEach((story) => {
  story.route = `${story.slug}`;
});
